import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./GraphsNotEnoughDataInMinutes.styles";
import AvTimerOutlinedIcon from "@mui/icons-material/AvTimerOutlined";

export const GraphsNotEnoughDataInMinutes = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <AvTimerOutlinedIcon className={classes.icon} />
            <Box className={classes.textContainer}>
                <Typography variant="h1" className={classes.title}>
                    {t("HMI.graphs_not_enough_data_in_minutes")}
                </Typography>
                <Typography variant="subtitle1" className={classes.subtitle}>
                    {t("HMI.check_occurrences")}
                </Typography>
            </Box>
        </Box>
    );
};
